import React, { useEffect, useState, useRef } from 'react';
import { QuestionRendererProps } from './types';
import { LatexRenderer } from '../../ui/LatexRenderer';
export function TableReadingRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const config = question.interactiveConfig || {};
  const table = config.table || {
    headers: [],
    rows: []
  };
  const prevValidateRef = useRef(false);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  // Reset state when question changes
  useEffect(() => {
    setSelectedIndex(null);
    prevValidateRef.current = false;
  }, [question.id]);
  // Reset validation flag when shouldValidate becomes false
  useEffect(() => {
    if (!shouldValidate) {
      prevValidateRef.current = false;
    }
  }, [shouldValidate]);
  useEffect(() => {
    onReadyChange?.(selectedIndex !== null);
  }, [selectedIndex, onReadyChange]);
  // Rising-edge detection for shouldValidate
  useEffect(() => {
    if (shouldValidate && !prevValidateRef.current && selectedIndex !== null) {
      prevValidateRef.current = true;
      onAnswer(String(selectedIndex));
    }
  }, [shouldValidate, selectedIndex, onAnswer]);
  return <div className="w-full max-w-2xl mx-auto overflow-hidden rounded-xl border border-slate-200 shadow-sm" data-id="element-4651">
      <table className="w-full text-left border-collapse" data-id="element-4652">
        <thead data-id="element-4653">
          <tr className="bg-slate-50 border-b border-slate-200" data-id="element-4654">
            {table.headers.map((header: string, i: number) => <th key={i} className="p-4 font-bold text-slate-700" data-id="element-4655">
                <LatexRenderer content={header} data-id="element-4656" />
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-4657">
          {table.rows.map((row: string[], rowIndex: number) => {
          const isSelected = selectedIndex === rowIndex;
          return <tr key={rowIndex} onClick={() => setSelectedIndex(rowIndex)} className={`
                  cursor-pointer transition-colors border-b border-slate-100 last:border-0
                  ${isSelected ? 'bg-indigo-50 text-indigo-900' : 'hover:bg-slate-50 text-slate-600'}
                `} data-id="element-4658">

                {row.map((cell: string, cellIndex: number) => <td key={cellIndex} className="p-4" data-id="element-4659">
                    <LatexRenderer content={cell} data-id="element-4660" />
                  </td>)}
              </tr>;
        })}
        </tbody>
      </table>

      <div className="bg-slate-50 p-3 text-center text-sm text-slate-500 border-t border-slate-200" data-id="element-4661">
        Klik op de juiste rij in de tabel
      </div>
    </div>;
}